module.exports = __webpack_public_path__ + "img/add-template.226b576c.svg";